import React from 'react';
import { KeyboardDetectionProvider } from '@spotify-internal/encore-web';
import { CompactViewProvider } from './CompactProvider';
import { NavBarWide } from './NavBarWide';
import { NavBarCompact } from './NavBarCompact';
import { MotionWrapper } from '../MotionWrapper';
export const NavBar = ({ colors, forcedUserState, className, }) => {
    return (React.createElement(MotionWrapper, null,
        React.createElement(KeyboardDetectionProvider, null,
            React.createElement(CompactViewProvider, null, isCompact => {
                return !isCompact ? (React.createElement(NavBarWide, { forcedUserState: forcedUserState, colors: colors, className: className })) : (React.createElement(NavBarCompact, { forcedUserState: forcedUserState, colors: colors, className: className }));
            }))));
};
//# sourceMappingURL=NavBar.js.map